module.exports = __webpack_public_path__ + "static/media/4.f58c878a.jpg";